import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3d919bca")

_pushScopeId("data-v-3d919bca")
const _hoisted_1 = { class: "ui__pageTitle_main" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_3 = { class: "ui__pageTitle_cnt" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "ui__pageTitle_left",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
    }, [
      _hoisted_2
    ]),
    _createVNode("div", _hoisted_3, _toDisplayString(_ctx.isBigImg? 'Фото автомобиля' : 'Все фото'), 1),
    _renderSlot(_ctx.$slots, "default")
  ]))
})